<main class="d-grid gap-4">
    <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
        <div class="header-text school-text">
            {{isShowMediaConsent ? "Student and Parent media consent form" : "Back to home"}}
        </div>
    </div>

    <div class="spinner" *ngIf="isLoading"></div>

    <!-- Event no longer available -->
    <div class="event-unavailable-card" *ngIf="!isLoading && (isEventCancelled() || !eventData)">
        <img src="assets/images/cross-icon.svg" class="unavailable-icon" alt="unavailable" />
        <div class="unavailable-title">This event is no longer available</div>
        <div class="unavailable-sub">The event you are looking for has been cancelled or is no longer active.</div>
    </div>

    <div class="event-details-card" *ngIf="!isShowMediaConsent && !isLoading && !isEventCancelled() && !!eventData">
        <!-- <div>
            <img [src]="getEventImage()" class="event-image" />
        </div> -->
        <div class="main-container">
            <div class="details-container">
                <div class="w-100 d-flex justify-content-between align-items-center flex-wrap">
                    <div class="d-flex justify-content-center gap-3 align-items-center flex-wrap">
                        <div class="event-heading">{{eventData?.eventName}}</div>
                        <div class="pd-points">
                            PD Points <span style="font-size: 18px; font-weight: 600; color: #0d6fd9;">
                                {{eventData?.pointValue ?? 0}}
                            </span>
                        </div>

                    </div>
                    <div class="primary-text d-flex align-items-center gap-2">
                        Status : <span [ngClass]=" getStatusClass(eventData?.eventStatus)"
                            style="cursor: default;">{{eventData?.eventStatus}}</span>
                    </div>
                </div>


                <!-- <div class="d-flex gap-3 align-items-center">
                    <div class="primary-text">End date :</div>
                    <div class="secondary-text"> {{eventData?.eventEndDate | brisbaneDate:'dd-MM-yyyy'}}
                    </div>
                </div> -->
                <div>
                    <div class="d-grid w-100 student-event-details" style="grid-template-columns: 1fr 1fr; gap: 2rem;">
                        <div class="d-flex gap-3 align-items-center">
                            <div class="primary-text">Date :</div>
                            <div class="secondary-text">
                                {{ (eventData?.eventStartDate | brisbaneDate:'dd-MM-yyyy') }}
                                -
                                {{ (eventData?.eventEndDate | brisbaneDate:'dd-MM-yyyy') }}
                            </div>
                        </div>

                        <div class="d-flex gap-3 align-items-center" *ngIf="eventData?.eventTime">
                            <div class="primary-text">Time :</div>
                            <div class="secondary-text">{{eventData?.eventTime}}</div>
                        </div>

                        <div class="d-flex gap-3 align-items-center">
                            <div class="primary-text">Event type :</div>
                            <div class="secondary-text">{{eventData?.eventType}}</div>
                        </div>

                        <div class="d-flex gap-3 align-items-center">
                            <div class="primary-text">Location :</div>
                            <div class="secondary-text">{{eventData?.location}}</div>
                        </div>

                        <div class="d-flex gap-3 align-items-center" *ngIf="eventSource === 'student-event'">
                            <div class="primary-text">Employer name :</div>
                            <div class="secondary-text">{{eventData?.employerName}}</div>
                        </div>

                        <div class="d-flex gap-3 align-items-center" *ngIf="eventData?.eventTypeDescription || eventData?.description">
                            <div class="primary-text">Description :</div>
                            <div class="secondary-text">{{eventData?.eventTypeDescription || eventData?.description}}</div>
                        </div>

                        <div class="d-flex justify-content-end" style="grid-column: span 2;">
                            <button *ngIf="eventSource !== 'csqEvents' && getEventImage() && !isPdf()"
                                (click)="downloadFiles()" class="evidence-button"
                                [style.opacity]="downloading ? 0.75 : 1" [class.disabled]="downloading">
                                <div class="time">
                                    <div class="d-flex gap-2 align-items-center px-2">
                                        <div *ngIf="downloading" class="spinner" style="margin: 0;width:20px;height:20px"></div>
                                        <img *ngIf="!downloading" class="download-icon" style="filter: brightness(5); width: 20px; height: 20px;"
                                            src="assets/images/Buttons/view-button.svg" alt="download" />
                                        View evidence
                                    </div>
                                </div>
                            </button>
                            <button *ngIf="eventSource !== 'csqEvents' && getEventImage() && isPdf()"
                                (click)="downloadFiles()" class="evidence-button"
                                [style.opacity]="downloading ? 0.75 : 1" [class.disabled]="downloading">
                                <div class="time">
                                    <div class="d-flex gap-2 align-items-center px-2">
                                        <div *ngIf="downloading" class="spinner" style="margin: 0;width:20px;height:20px"></div>
                                        <img *ngIf="!downloading" class="download-icon" src="assets/images/download-icon.svg" alt="download" />
                                        {{ downloading ? 'Downloading...' : 'Download evidence' }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>




                </div>


            </div>

            <div class="d-grid gap-3 mt-3">
                <!-- (click)="onMediaConsent($event)" -->

                <div class="d-grid gap-3">
                    <!-- <button *ngIf="true" class="reg-btn">Download</button> -->
                    <div class="d-flex gap-3">
                        <button *ngIf="eventData?.mediaConsentStatus === 'Approved'" class="media-succes-btn">
                            Media consent form completed
                        </button>
                        <button class="media_viewButton" (click)="onMediaConsent($event)"
                            *ngIf="eventData?.mediaConsentStatus === 'Approved'">
                            <img class="download-icon" style="filter:brightness(50);width: 20px; height: 20px; "
                                src="assets/images/Buttons/view-button.svg" alt="download" />
                        </button>
                    </div>

                    <button (click)="onMediaConsent($event)"
                        *ngIf="eventData?.mediaConsentStatus === 'Not Approved' || eventData?.mediaConsentStatus=== 'Pending' && isRegistered  && !showConsentButton && eventSource !== 'student-event'"
                        class=" media-succes-btn red-color" style="cursor: pointer;">Go to Media Consent</button>

                </div>

                <div class="d-flex flex-column gap-3">
                    <!-- *ngIf="eventData?.eventStatus !== 'Rejected'" -->
                    <button *ngIf="getLabelByStatus() == 'register'  && eventData?.eventStatus !== 'Upcoming'"
                        class="reg-btn cursor-none">Registration no longer available</button>
                    <button [disabled]="isSubmitting"
                        *ngIf="(getLabelByStatus() === 'register') && eventData?.eventStatus === 'Upcoming'"
                        class="reg-btn" (click)="onRegister($event)">
                        {{isSubmitting ? "Registering..." :"Register"}}

                    </button>
                    <button *ngIf="getLabelByStatus() == 'TeacherReviewPending'"
                        class="reg-btn  cursor-none clr-change pending">Teacher review pending</button>
                    <button *ngIf="getLabelByStatus() == 'rejected'"
                        class="reg-btn cursor-none clr-change rejected">Declined</button>
                    <button *ngIf="getLabelByStatus() == 'unregister'" class="reg-btn clr-change cancel"
                        (click)="onCancelRegister()">Cancel registration</button>
                </div>

            </div>

        </div>

    </div>

    <div *ngIf="isShowMediaConsent && !isLoading && eventData">
        <app-consent-form [isStudent]="true" [mediaToken]="mediaToken" [data]="eventData"
            (consentSubmitted)="onConsentSubmitted()">
        </app-consent-form>
    </div>



    <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <div></div>
                <button class="close-btn" (click)="closeEventModal()">&times;</button>
            </div>

            <div class="modal-body">
                <img [src]="showEventModal" alt="Event Image" />
            </div>
        </div>
    </div>
</main>